import { AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, OnInit, Renderer2, ViewChild } from '@angular/core';
import { Url } from '@df/core/service/url';
import { HrefComponent } from '@df/ui/common/href/href.component';
import { SizeClassDirective } from '@df/ui/common/size-class.directive';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { ICmsComponent, ICmsContent, NICmsContentComponent, NICmsContentField } from '@icms/core/content';
export interface PageComponentInstagramFeedData extends NICmsContentComponent.IData {
    snappptUrl?: string;
    title?: string;
    titleLink?: string;
    subtitle?: string;
    ctaText?: string;
    ctaLink?: string;
}
@ICmsComponent<PageComponentInstagramFeedComponent>({
    id: 'instagram-feed',
    name: 'Instagram feed',
    tags: ['UGC', 'instagram', 'snapppt'],
    fields: [
        <NICmsContentField.IField>{
            key: 'snappptUrl',
            type: NICmsContentField.EFieldType.text,
            title: 'Snapppt URL'
        },
        <NICmsContentField.IField>{
            key: 'title',
            type: NICmsContentField.EFieldType.text,
            title: 'Title',
            default: '@lemieuxproductsofficial'
        },
        <NICmsContentField.IField>{
            key: 'titleLink',
            type: NICmsContentField.EFieldType.text,
            title: 'Title Link'
        },
        <NICmsContentField.IField>{
            key: 'subtitle',
            type: NICmsContentField.EFieldType.text,
            title: 'Subtitle',
            default: 'Share your style using #lovelemieux'
        },
        <NICmsContentField.IField>{
            key: 'ctaText',
            type: NICmsContentField.EFieldType.text,
            title: 'CTA Text',
            default: 'Follow us'
        },
        <NICmsContentField.IField>{
            key: 'ctaLink',
            type: NICmsContentField.EFieldType.text,
            title: 'CTA Link'
        }
    ]
})
@Component({
    selector: 'page-component-instagram-feed',
    templateUrl: './instagram-feed.html',
    styleUrls: ['instagram-feed.scss'],
    standalone: true,
    imports: [SizeClassDirective, HrefComponent, ICmsClientModule],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PageComponentInstagramFeedComponent extends UiComponent implements NICmsContentComponent.IComponent, AfterViewInit, OnInit {
    @ICmsContent({
        type: 'component'
    })
    component!: PageComponentInstagramFeedData;
    @ViewChild('instagramFeedRef', { static: true })
    instagramFeedRef!: ElementRef;

    constructor(
        private renderer2: Renderer2,
        private url: Url,
        protected elementRef: ElementRef
    ) {
        super();
    }
    ngAfterViewInit() {
        if (this?.instagramFeedRef) {
            this.init(this.instagramFeedRef);
        }
    }

    protected init(elementRef: ElementRef) {
        elementRef.nativeElement.innerHTML = '';
        const script = this.renderer2.createElement('script');
        script.type = 'text/javascript';
        script.src =
            this.component?.snappptUrl ||
            'https://snapppt.com/widgets/widget_loader/d5bb9e25-a67e-4e83-a139-69948082924f/sauce_homepage.js';
        script.classList.add('snapppt-widget');
        script.setAttribute('data-custom-visit-url', this.url.toUrl('/PRODUCT_HANDLE'));

        this.renderer2.appendChild(elementRef.nativeElement, script);
    }
}
